// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2PtED","requiredAsterisk":"Info_requiredAsterisk__1HlNo"};